// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BusinessAdminResponse

import { BillingSanctionLevel } from './enums.gen';
import { hydrateWidget, type Widget, type WidgetApiResponse } from './widget.gen';
import { hydrateContractAdditionalLine, type ContractAdditionalLine, type ContractAdditionalLineApiResponse } from './contractAdditionalLine.gen';
import { hydrateUser, type User, type UserApiResponse } from './user.gen';
import { hydrateWidgetGoogleReserve, type WidgetGoogleReserve, type WidgetGoogleReserveApiResponse } from './widgetGoogleReserve.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BusinessAdminApiResponse = {
	id: string;
	name: string;
	logo: string;
	address: string;
	country: string;
	website: string | null;
	googleReviewsUrl: string | null;
	timezone: string;
	fontFamily: string | null;
	registrationDate: string;
	widgets: WidgetApiResponse[];
	contractIsActive: boolean;
	sanctionLevel: BillingSanctionLevel;
	billingEmails: Array<string>;
	isStripeLegacyIndirect: boolean;
	isSplitPaymentEnabled: boolean;
	splitPaymentThreshold: number;
	splitPaymentDelay: number;
	splitPaymentOwnerFee: number;
	splitPaymentFee: number;
	isStripeManagedByReservatoo: boolean;
	revenues: number;
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	frequency: number;
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	billingEnabled: boolean;
	cancelAtPeriodEnd: boolean;
	nextInvoiceAdditionalLines: ContractAdditionalLineApiResponse[];
	hasOpenInvoice: boolean;
	hasProcessingPayment: boolean;
	owner: UserApiResponse;
	defaultOfferCollectionId: string;
	package: string;
	stripeCustomerId: string | null;
	stripeAccountId: string | null;
	lastBookingCreatedAt: string | null;
	landingPageOrigin: string | null;
	googleReserve: WidgetGoogleReserveApiResponse | null;
	nextInvoiceDate: string | null;
	sanctionLevelDegradeDate: string | null;
	qontoCustomerId: string | null;
};

export type BusinessAdmin = {
	id: string;
	name: string;
	logo: string;
	address: string;
	country: string;
	website: string | null;
	googleReviewsUrl: string | null;
	timezone: string;
	fontFamily: string | null;
	registrationDate: DateTime;
	widgets: Widget[];
	contractIsActive: boolean;
	sanctionLevel: BillingSanctionLevel;
	billingEmails: Array<string>;
	isStripeLegacyIndirect: boolean;
	isSplitPaymentEnabled: boolean;
	splitPaymentThreshold: number;
	splitPaymentDelay: number;
	splitPaymentOwnerFee: number;
	splitPaymentFee: number;
	isStripeManagedByReservatoo: boolean;
	revenues: number;
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	frequency: number;
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	billingEnabled: boolean;
	cancelAtPeriodEnd: boolean;
	nextInvoiceAdditionalLines: ContractAdditionalLine[];
	hasOpenInvoice: boolean;
	hasProcessingPayment: boolean;
	owner: User;
	defaultOfferCollectionId: string;
	package: string;
	stripeCustomerId: string | null;
	stripeAccountId: string | null;
	lastBookingCreatedAt: DateTime | null;
	landingPageOrigin: string | null;
	googleReserve: WidgetGoogleReserve | null;
	nextInvoiceDate: DateTime | null;
	sanctionLevelDegradeDate: DateTime | null;
	qontoCustomerId: string | null;
};

export function hydrateBusinessAdmin(data: BusinessAdminApiResponse): BusinessAdmin {
	return {
		...data,
		registrationDate: DateTimefromISO(data.registrationDate)!,
		widgets: data.widgets.map(hydrateWidget),
		nextInvoiceAdditionalLines: data.nextInvoiceAdditionalLines.map(hydrateContractAdditionalLine),
		owner: hydrateUser(data.owner),
		lastBookingCreatedAt: DateTimefromISO(data.lastBookingCreatedAt),
		googleReserve: data.googleReserve ? hydrateWidgetGoogleReserve(data.googleReserve) : null,
		nextInvoiceDate: DateTimefromISO(data.nextInvoiceDate),
		sanctionLevelDegradeDate: DateTimefromISO(data.sanctionLevelDegradeDate),
	};
}